module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/1@2x_2d43cbdb5d71edfad0b708d242929605.png";